<template>
    <div>
        <page-title>插件授权</page-title>
        <page-body>
            <list-header>
                <div flex="dir:left box:last cross:center">
                    <div>
                        <el-button type="text" @click="showCreateDialog = true">手动添加</el-button>
                    </div>
                    <div flex>
                        <div style="margin-right: 8px">
                            <el-date-picker
                                size="mini"
                                @change="dateChange"
                                v-model="date"
                                type="datetimerange"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="app_id"
                                       clearable size="mini"
                                       placeholder="应用" @change="search()">
                                   <el-option v-for="item in apps" :key="item.id" :label="item.display_name"
                                        :value="item.id"></el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-select style="width: 120px;margin-right: 10px"
                                       v-model="is_pay"
                                       clearable size="mini"
                                       placeholder="状态" @change="search()">
                                <el-option v-for="item in isPayOptions" :key="item.value" :label="item.label"
                                           :value="item.value">
                                </el-option>
                            </el-select>
                        </div>
                        <div>
                            <el-input v-model="keyword"
                                      @keyup.enter.native="search()"
                                      size="mini"
                                      placeholder="插件/站点名称/域名"
                                      suffix-icon="el-icon-search"/>
                        </div>
                    </div>
                </div>
            </list-header>
            <el-table v-loading="loading" :data="list" style="width: 100%">
                <el-table-column prop="plugin.display_name" label="插件"></el-table-column>
                <el-table-column prop="app.display_name" label="应用"></el-table-column>
                <el-table-column prop="host" label="站点">
                    <template slot-scope="scope">
                        <div>{{scope.row.host.name}}</div>
                        <div>{{scope.row.host.domain}}</div>
                        <div style="font-size: 12px;color: #909090" v-if="scope.row.log && scope.row.log.user && scope.row.log.user.name">授权人: {{scope.row.log.user.name}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="order_no" label="订单">
                    <template slot-scope="scope">
                        <div>{{scope.row.order_no}}</div>
                        <div>
                            <el-button type="text" @click="updatePayPrice(scope.row)">￥{{scope.row.pay_price}}<i
                                    class="el-icon-edit"></i></el-button>
                            <span style="text-decoration: line-through;font-size: 12px;margin-left: 5px;color: #999">{{scope.row.price}}</span>
                        </div>
                        <view-certificate v-if="scope.row.certificate_url" v-model="scope.row.certificate_url" :mark="scope.row.mark"></view-certificate>
                        <div style="font-size: 12px;color: #999">{{scope.row.add_time}}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="is_pay" label="状态">
                    <template slot-scope="scope">
                        <span style="color: #909399" v-if="scope.row.is_pay === 0">未支付</span>
                        <span style="color: #67C23A" v-else-if="scope.row.is_pay === 1">已授权</span>
                    </template>
                </el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <template v-if="scope.row.is_delete === 0">
                            <el-button type="text" v-if="scope.row.is_pay === 0" @click="updateIsPay(scope.row, 1)">
                                授权通过
                            </el-button>
                            <el-button type="text" v-else @click="updateIsPay(scope.row, 0)">取消授权</el-button>
                            <span class="text-split">|</span>
                        </template>
                        <el-button type="text" v-if="scope.row.is_delete === 0"
                                   @click="updateIsDelete(scope.row,1)">删除
                        </el-button>
                        <el-button type="text" v-else @click="updateIsDelete(scope.row, 0)">恢复</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                    style="margin: 20px -5px;padding: 0"
                    background
                    layout="prev, pager, next"
                    @current-change="pageChange"
                    :total="parseInt(pagination && pagination.totalCount ? pagination.totalCount : 0)">
            </el-pagination>

            <el-dialog title="手动添加插件授权" :visible.sync="showCreateDialog" :close-on-click-modal="false">
                <el-form :model="form" :rules="rules" ref="form" label-position="top">
                    <el-form-item label="站点" prop="host_id">
                        <el-select style="width: 100%" v-model="form.host_id"
                                   filterable
                                   remote
                                   reserve-keyword
                                   :loading="searchData.hostsLoading"
                                   placeholder="请输入关键词"
                                   :remote-method="searchHost">
                            <el-option
                                    v-for="item in searchData.hosts"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                                <span style="float: left">{{ item.name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">{{ item.domain }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="应用" prop="app_id">
                        <el-select style="width: 100%" v-model="form.app_id" filterable placeholder="请选择" @change="searchApps()">
                            <el-option
                                    v-for="item in apps"
                                    :key="item.id"
                                    :label="item.display_name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="插件" prop="plugin_id" v-if="form.app_id">
                        <el-select style="width: 100%" v-model="form.plugin_id"
                                   filterable
                                   remote
                                   reserve-keyword
                                   :loading="searchData.pluginsLoading"
                                   placeholder="请输入关键词"
                                   :remote-method="searchPlugins">
                            <el-option
                                    v-for="item in searchData.plugins"
                                    :key="item.id"
                                    :label="item.display_name"
                                    :value="item.id">
                                <span style="float: left">{{ item.display_name }}</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">￥{{ item.price }}</span>
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="授权状态" prop="is_pay">
                        <el-radio v-model="form.is_pay" :label="0">未授权</el-radio>
                        <el-radio v-model="form.is_pay" :label="1">已授权</el-radio>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="createSubmit" :loading="submitLoading">提交</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>
        </page-body>
    </div>
</template>

<script>
import axios from '@/axios'
import helper from '@/helper'

export default {
    components: {
        'ViewCertificate': () => import('@/components/ViewCertificate.vue')
    },
    data() {
        return {
            app_id: null,
            showCreateDialog: false,
            loading: false,
            list: null,
            pagination: null,
            is_pay: null,
            host_id: null,
            plugin_id: null,
            keyword: '',
            isPayOptions: [
                {
                    label: '未支付',
                    value: 0
                },
                {
                    label: '已授权',
                    value: 1
                }
            ],
            apps: [],
            searchData: {
                hostsLoading: false,
                hosts: [],
                pluginsLoading: false,
                plugins: []
            },
            submitLoading: false,
            form: {
                host_id: null,
                plugin_id: null,
                is_pay: null
            },
            rules: {
                host_id: [
                    {required: true}
                ],
                app_id: [
                    {required: true}
                ],
                plugin_id: [
                    {required: true}
                ],
                is_pay: [
                    {required: true}
                ]
            },
            date: null,
            start_at: null,
            end_at: null
        }
    },
    created() {
        this.app_id = Number(this.$route.query.app_id) || null
        this.host_id = this.$route.query.host_id || null
        this.plugin_id = this.$route.query.plugin_id || null
        this.loadData(0)
        this.searchApps()
    },
    methods: {
        searchHost(keyword) {
            this.searchData.hostsLoading = true
            axios({
                url: 'admin/host/index',
                params: {
                    keyword: keyword,
                    status: 1
                }
            }).then(e => {
                this.searchData.hostsLoading = false
                if (e.data.code === 0) {
                    this.searchData.hosts = e.data.data.list
                } else {
                    this.searchData.hosts = []
                }
            }).catch(e => {
                this.searchData.hosts = []
            })
        },
        searchPlugins(keyword) {
            this.searchData.pluginsLoading = true
            axios({
                url: 'admin/plugin/index',
                params: {
                    app_id: this.app_id,
                    keyword: keyword
                }
            }).then(e => {
                this.searchData.pluginsLoading = false
                if (e.data.code === 0) {
                    this.searchData.plugins = e.data.data.list
                } else {
                    this.searchData.plugins = []
                }
            }).catch(e => {
                this.searchData.plugins = []
            })
        },
        createSubmit() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    this.submitLoading = true
                    axios({
                        url: 'admin/plugin-order/create',
                        data: this.form,
                        method: 'post'
                    }).then(e => {
                        this.submitLoading = false
                        if (e.data.code === 0) {
                            this.$message.success(e.data.msg)
                            this.showCreateDialog = false
                            this.loadData(0)
                        } else {
                            this.$message.error(e.data.msg)
                        }
                    }).catch(e => {
                    })
                } else {
                }
            })
        },
        loadData(page) {
            if (this.date) {
                this.start_at = this.date[0]
                this.end_at = this.date[1]
            } else {
                this.start_at = null
                this.end_at = null
            }
            this.getList(page).then(e => {
                this.list = e.list
                this.pagination = e.pagination
            })
        },
        getList(page) {
            return new Promise(resolve => {
                this.loading = true
                axios({
                    url: 'admin/plugin-order/index',
                    params: {
                        app_id: this.app_id,
                        page: page,
                        keyword: this.keyword,
                        is_pay: this.is_pay,
                        host_id: this.host_id,
                        plugin_id: this.plugin_id,
                        start_at: this.start_at,
                        end_at: this.end_at
                    }
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        resolve(e.data.data)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        search() {
            this.loadData(0)
        },
        pageChange(page) {
            this.loadData(page - 1)
        },
        updateIsDelete(item, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认恢复订单？'
            } else {
                content = '是否确认删除订单？'
            }
            new Promise(resolve => {
                this.$confirm(content, '提示', {
                    type: 'warning'
                }).then(() => {
                    resolve(item)
                }).catch(() => {
                })
            }).then(item => {
                const data = helper.clone(item)
                data.is_delete = status
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/plugin-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.is_delete = status
                        this.$message.success(e.data.msg)
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            })
        },
        updateIsPay(item, status) {
            let content = ''
            if (status === 0) {
                content = '是否确认取消授权？'
            } else {
                content = '是否确认授权通过？'
            }
            this.$confirm(content, '提示', {}).then(() => {
                const data = helper.clone(item)
                data.is_pay = status
                data.pay_type = status === 1 ? 1 : 0
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/plugin-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.is_pay = status
                        this.$message.success('操作成功。')
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        },
        updatePayPrice(item) {
            let content = `订单原价: <span style="color: #999;text-decoration: line-through">${item.price}</span><br>`
            content += `支付金额: ${item.pay_price}<br>`
            content += `请输入订单需支付的金额:`
            this.$prompt(content, '修改价格', {
                dangerouslyUseHTMLString: true
            }).then(({value}) => {
                const data = helper.clone(item)
                data.pay_price = value
                delete data.host
                delete data.user
                delete data.plugin
                this.loading = true
                axios({
                    url: 'admin/plugin-order/update',
                    method: 'post',
                    data: data
                }).then(e => {
                    this.loading = false
                    if (e.data.code === 0) {
                        item.pay_price = value
                        this.$message.success('操作成功。')
                    } else {
                        this.$message.error(e.data.msg)
                    }
                })
            }).catch(() => {
            })
        },
        dateChange() {
            this.loadData(0)
        },
        searchApps() {
            axios({
                url: 'admin/app/index'
            }).then(e => {
                if (e.data.code === 0) {
                    this.apps = e.data.data.list
                } else {
                    this.apps = []
                }
            }).catch(e => {
                this.apps = []
            })
        }
    }
}
</script>

<style scoped>

</style>
